export default __webpack_public_path__ + "static/media/p2023-24.ba6510e1.jpeg";